import { gql } from '@apollo/client';

export const QUERYV2 = gql`
  mutation UpgradeSubscriptionByToken($payload: AutoFilledUpgradeSubscriptionPayload!, $token: String!) {
    upgradeSubscriptionByToken(payload: $payload, token: $token) {
      nextAction
      subscriptions {
        _id
        amountDue
        billingCycleCount
        cancelDate
        cancelReason
        createdAt
        endDate
        frequency
        has3dsVerification
        incompleteBillingDetails
        isCancelling
        nextPaymentAttemptDate
        paymentReminderEndDate
        nextBillingDate
        updatedAt
        startDate
        status
        seats
        company {
          _id
          name
        }
        customer {
          _id
          email
          companyName
          defaultPaymentMethod
          defaultPaymentMethodObj {
            name
            type
            customerId
            _id
            card {
              cardNo
              cardType
              holder
              expiry
            }
          }
        }
        product {
          _id
          name
          group
          description
          defaultPrice
          unitLabel
          billingCycle
        }
        pricing {
          _id
          name
          description
          months
          years
          direction
        }
      }
    }
  }
`;
